export const TRAINING_SERVER_AXIOS_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL,
};

export const EDX_AXIOS_CONFIG = {
  baseURL: process.env.REACT_APP_EDX_API_URL,
  withCredentials: true,
};
